const reducePropIdList = require('./reducePropIdList')

const reduceSourceList = reducePropIdList('source')

module.exports = reduceSourceList
